import { ChangeEvent, InputHTMLAttributes, useRef } from 'react';

export default function PhoneNumberInput({ value, onChange }: InputHTMLAttributes<HTMLInputElement> ) {
  const keyCode = useRef<string>();

  const onPhoneNumberInput = (evt: ChangeEvent<HTMLInputElement>) => {
    const backspace = (keyCode.current && keyCode.current === 'Backspace') ? true : false;
    if (evt) {
      let ret = evt.target.value.replace(/\D/g, '');
      if (backspace && ret.length <= 6) {
        ret = ret.substring(0, ret.length - 1);
      }
      if (ret.length === 0) {
        ret = '';
        if (onChange) onChange(evt);
        return;
      }
      else if (ret.length <= 3) {
        ret = ret.replace(/^(\d{0,3})/, '($1)');
      }
      else if (ret.length <= 6) {
        ret = ret.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
      }
      else if (ret.length <= 10) {
        ret = ret.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
      }
      else {
        ret = ret.substring(0, 10);
        ret = ret.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
      }
      evt.target.value = ret;
      if (onChange) onChange(evt);
    }
  }

  return (
    <input
      type='text'
      value={value}
      onChange={evt => onPhoneNumberInput(evt)}
      onKeyDown={(evt) => keyCode.current = evt.code}
      name='phone'
      placeholder='*Phone Number'
    />
  )
}
